// extracted by mini-css-extract-plugin
export default {"nameContainer":"nameEditor_nameContainer__wYxTj","label":"nameEditor_label__33VTY","customNameInput":"nameEditor_customNameInput__8DpsX"};